import Vue from 'vue'
import { mergeData } from 'vue-functional-data-merge'

export default Vue.extend({
  name: 'WeveIcon',
  functional: true,
  render(h, { data }) {
    return h(
      'svg',
      mergeData(data, {
        attrs: { viewBox: '0 0 512 308' },
        staticClass: 'svg-icon',
      }),
      [
        h('path', {
          attrs: {
            d: 'M151 293c34 20 78 8 98-26l27-47c-7 30 6 62 34 78 34 19 78 8 98-26l94-161c20-34 9-77-25-97-35-19-78-7-98 26l-28 47c8-30-5-62-33-78-35-19-78-7-98 27l-38 64c12-32 0-68-31-86-34-19-78-7-98 26l-43 74c-20 34-9 77 26 97 30 17 69 9 91-17l-2 3c-20 34-8 77 26 96z',
          },
        }),
      ]
    )
  },
})
